export const BATCH_ADD_FILETYPE = '.xlsx';

export enum EMasterScheduleBatchAddJsonKey {
  T1_REF_NO = 'T1 No.',
  T1_HEADER = 'T1 Header',
  DESIGN_PACKAGE = 'Design Package',
  RISK_CATEGORY = 'Risk Category',
  VO_ITEM = 'VO Item',
  REQUIRE_WORK_PROCEDURE_DRAWING = 'Require Work Procedure Drawing (Y/N)',
  FALSEWORK = 'Falsework (Y/N)',
  PROCUREMENT_DATE = 'Procurement/Fabrication (YYYY-MM-DD)',
  START_CONSTRUCTION_DATE = 'Start Construction (YYYY-MM-DD)',
  REMOVAL_OR_REDUNDANT_DATE = 'Removal/Redundant (YYYY-MM-DD)',
  REMARKS = 'Remarks',
}

export enum EMasterScheduleBatchAddFormKey {
  MASTER_SCHEDULES = 'masterSchedules',
  FILE = 'file',
}
